const featureOSScript = document.createElement('script')
featureOSScript.src = 'https://widgets-v3.featureos.app/widget.js'
document.body.prepend(featureOSScript)
